import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReadyToGrowYourRestaurant() {
  return <section data-section-id="246926" id="call-to-action" className="py-24 bg-secondary text-secondary-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary to-transparent" />
      
      <div className="container mx-auto px-4 relative z-10 flex flex-col items-center text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-secondary-foreground mb-6 tracking-tight max-w-4xl">
          Secure Your Property Investment Today
        </h2>
        
        <p className="text-lg md:text-xl text-secondary-foreground/80 mb-10 max-w-2xl font-default leading-relaxed">
          Don't leave your home's safety to chance. Schedule a comprehensive 4-point inspection with South Florida's most trusted certified professionals.
        </p>
        
        <Button asChild size="lg" className="rounded-md text-lg px-10 py-7 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1 bg-primary text-primary-foreground hover:bg-primary/90">
          <Link to="/FourPointInspectionSouthFloridaPage">
            Book Your Inspection Now
          </Link>
        </Button>
      </div>
    </section>;
}